import { jsxs, jsx } from "react/jsx-runtime";
import { Component } from "react";
import SmileyChatIcon from "./SmileyChatIcon.js";
class FinalView extends Component {
  render() {
    return /* @__PURE__ */ jsxs("div", { id: "chat-view", className: "final-view", children: [
      /* @__PURE__ */ jsxs("div", { className: "final-thanks", children: [
        /* @__PURE__ */ jsx(SmileyChatIcon, { className: "large" }),
        /* @__PURE__ */ jsx("span", { className: "thanks", children: "Thanks for the feedback" })
      ] }),
      /* @__PURE__ */ jsx("span", { className: "enjoy-rest-of-day", children: "Enjoy the rest of your day" })
    ] });
  }
}
export {
  FinalView as default
};
//# sourceMappingURL=FinalView.js.map
